import React, { useState, createContext } from "react"

export const ConstantsContext = createContext({
    updateList: false,
    setUpdateList: () => {},

    constantUnites: [],
    setConstantUnites: () => {}
})

export default function ConstantsProvider(props) {
    const { children } = props
    const [updateList, setUpdateList] = useState(false)
    const [constantUnites, setConstantUnites] = useState([])

    return (
        <ConstantsContext.Provider
            value={{
                updateList,
                setUpdateList,

                constantUnites,
                setConstantUnites
            }}
        >
            {children}
        </ConstantsContext.Provider>
    )
}
